import {
  AnalyticsGTM,
  IG4DefaultParams,
} from '@quicktools/shared-components/services/analytics-gtm';
import ReactGA4 from 'react-ga4';

import { TOOL_NAME, VERSION } from '../../configs';

export enum EventEnum {
  copyFont = 'copy_font',
  copiedFontIndex = 'copied_font_index',
  textBoxClick = 'text_box_click',
  textBoxType = 'text_box_type',
  loadMoreFonts = 'load_more_yfonts',
  loadedFonts = 'loaded_fonts',
}

class Analytics extends AnalyticsGTM {
  async init() {
    super.init();
  }

  public sendEvent(action: string, params: IG4DefaultParams) {
    this.sendGaEvent(action, params);
  }
}

const analytics = new Analytics(
  {
    VERSION,
    TOOL_NAME,
  },
  ReactGA4,
);

export default analytics;
